<template>
    <b-button-group size="sm" class="btn-block">
        <b-button
            :pressed="todoFilter === 'undone'"
            variant="outline-secondary"
            @click="updateTodoFilter('undone')"
        >
            Non faites
        </b-button>
        <b-button
            :pressed="todoFilter === 'late'"
            variant="outline-danger"
            @click="updateTodoFilter('late')"
        >
            En retard
        </b-button>
        <b-button
            :pressed="todoFilter === 'soon'"
            variant="outline-warning"
            @click="updateTodoFilter('soon')"
        >
            A venir
        </b-button>
        <b-button
            :pressed="todoFilter === 'done'"
            variant="outline-success"
            @click="updateTodoFilter('done')"
        >
            Faites
        </b-button>
    </b-button-group>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater'

export default {
    name: 'TodoFilter',

    mixins: [DataUpdater],

    methods: {
        updateTodoFilter(value) {
            this.$store.commit('browsing/SET_TODO_FILTER', value)
            if (this.updateAfterFiltering) {
                this.updateData()
            }
        },
    },

    computed: {
        ...mapState({
            todoFilter: (state) => state.browsing.todoFilter,
            activePage: (state) => state.browsing.pageName,
        }),

        updateAfterFiltering() {
            return (
                this.activePage !== 'ownTasks' &&
                this.activePage !== 'delegatedTasks'
            )
        },
    },
}
</script>

<style scoped></style>
